import { getDefaultCheckListConfig } from '@psl/flows/seller-onboarding/functions/useDefaultCheckListConfig';
import { SellerOnboardingPropsContext } from '@psl/flows/seller-onboarding/Provider';
import {
  SellerOnboardingContextProps,
  StepState,
} from '@psl/flows/seller-onboarding/types';
import { usePublicConfig } from '@psl/functions/hooks/usePublicConfig';
import { SellerOnboardingConfig } from '@psl/models/ClientModels';
import { memo, useContext, useEffect, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';

export const useDefaultContextProps = (
  config: SellerOnboardingConfig | undefined,
): SellerOnboardingContextProps =>
  useMemo(
    () => ({
      enabled: false,
      steps$: new BehaviorSubject<StepState[]>([]),
      config,
      synthesizedCheckListConfig: getDefaultCheckListConfig({
        isCreator: false,
        isPslPayEnabled: false,
        isPslPayEnforced: false,
        overriddenRequired: false,
      }),
      forceCompletionBeforeProceeding: false,
      sellerOnboardingCompleted: true,
      shouldPresent: false,
    }),
    [config],
  );

export const SellerOnboardingDefaultInitializer = memo(() => {
  const { props$ } = useContext(SellerOnboardingPropsContext);
  const publicConfig = usePublicConfig();
  const defaultProps = useDefaultContextProps(publicConfig.seller_onboarding);
  useEffect(() => {
    props$.next(defaultProps);
  }, [defaultProps, props$]);
  return null;
});

export default SellerOnboardingDefaultInitializer;
